import { render, staticRenderFns } from "./FormSubTitle.vue?vue&type=template&id=26d64eca&scoped=true"
import script from "./FormSubTitle.vue?vue&type=script&lang=js"
export * from "./FormSubTitle.vue?vue&type=script&lang=js"
import style0 from "./FormSubTitle.vue?vue&type=style&index=0&id=26d64eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d64eca",
  null
  
)

export default component.exports